export default __webpack_public_path__ + "static/media/notebook_drillhole.da837c80.png";